import { render, staticRenderFns } from "./grid-body-row-group.vue?vue&type=template&id=5c6e1e5d&scoped=true&"
import script from "./grid-body-row-group.vue?vue&type=script&lang=js&"
export * from "./grid-body-row-group.vue?vue&type=script&lang=js&"
import style0 from "./grid-body-row-group.vue?vue&type=style&index=0&id=5c6e1e5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e1e5d",
  null
  
)

export default component.exports